import FieldText from "../text/text"
import FieldTextWithVariables_FormElementView from "./render/form-element-view"
import {TextareaVariable} from "../../../gd-components/textarea-with-variables/textarea-with-variables"

// Multi-line text field whose form element renders `TextareaWithVariables`
// instead of a plain textarea — `{TOKEN}` placeholders in `config.tokens`
// render as pills and can be inserted via the Add-field popover.
// `config.singleLine` switches the form element to the single-line variant.
export default class FieldTextWithVariables extends FieldText {

    public tokens     : TextareaVariable[]
    public singleLine : boolean

    constructor(config: any) {
        super(config)

        this.typeLabel       = "Text with variables"
        this.typeDescription = "Text input with insertable {TOKEN} variables"
        this.icon            = config.icon || 'i5-formula'

        this.tokens          = _.get(config, 'tokens', [])
        this.singleLine      = _.get(config, 'singleLine', false)

        this.renderComponents.formElementView = FieldTextWithVariables_FormElementView
    }
}
